import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative inline-block text-left" }
const _hoisted_2 = {
  key: 0,
  class: "absolute right-0 mt-2 w-40 origin-top-right bg-white border border-primary-font/30 rounded-lg shadow-xl overflow-hidden z-50"
}
const _hoisted_3 = { class: "text-sm text-primary-font" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "flex items-center p-1 rounded-md text-primary-font text-sm font-bold hover:opacity-80 transition select-none cursor-pointer",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)), ["stop"]))
    }, [
      _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fas fa-book mr-1" }, null, -1)),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('menu.documentMgm')), 1)
    ]),
    (_ctx.open)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dropdownDownload, (listdoc, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: "flex items-center px-3 py-2 hover:bg-primary cursor-pointer",
                onClick: ($event: any) => (_ctx.selectDoc(listdoc))
              }, [
                _createElementVNode("img", {
                  src: listdoc.pic,
                  alt: "",
                  class: "w-5 h-5 object-cover"
                }, null, 8, _hoisted_5),
                _createElementVNode("span", _hoisted_6, _toDisplayString(listdoc.name), 1)
              ], 8, _hoisted_4))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}